import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps } from 'next'

import { internalAuthApi } from '../../api'
import { AuthLayout, CpfNotVerified } from '../../components'
import { withCampaignFallback } from '../../utils/campaign-attribution'
import { type AuthPageEventData, getEventDataFromQuery } from '../../utils/event-data'

export interface CpfNotVerifiedPageProps {
  eventData: AuthPageEventData
  csrfToken?: string | null
}

export function CpfNotVerifiedPage({ eventData }: CpfNotVerifiedPageProps) {
  return (
    <AuthLayout>
      <CpfNotVerified eventData={eventData} />
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { csrfToken } = await internalAuthApi.getCsrfToken(ctx)
  const eventData = withCampaignFallback(getEventDataFromQuery(ctx.query), ctx.query, ctx)

  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      eventData,
      csrfToken,
    },
  }
}

export const CpfNotVerifiedPageExports = {
  getServerSideProps,
}
